import React from 'react';

//import Scss
import './assets/scss/themes.scss';
import "./App.css"

//imoprt Route
import Route from './Routes';
import { ToastContainer } from 'react-toastify';


function App() {
  return (
    <React.Fragment>
      <ToastContainer/>
      <Route />
    </React.Fragment>
  );
}

export default App;
